import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { GraphqlService } from "./graphql.service";
import { MatDialog } from '@angular/material/dialog';
import { constObj } from 'src/app/common/Constants/constants';
import { ConfirmDialogComponent } from 'src/app/common/shared-components/confirm-dialog/confirm-dialog.component';
import { CommonDataService } from 'src/app/common/services/common-data.service';


@Injectable({
  providedIn: 'root'
})

export class OpenLinkById {

  constructor(private route: Router, private graphQlService: GraphqlService, private commonDataService: CommonDataService,
    public dialog: MatDialog,) { }

  openLinkById(event, isSitesBucket = false) {    
    let id = event.target.getAttribute('id');
    let classname = event.target.getAttribute('class');
    if (id !== null) {
      if (id.trim()[0] === '/') {
        this.route.navigateByUrl(id);
      }
      else if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {
        this.graphQlService.getS3BucketPath().subscribe(data => {
          let url = data + "/" + id;
          window.open(url);
        });
      }
      //TODO: remove after ID is given with .pdf 
      //else if (classname.includes('pdf-link')) {
      //  this.graphQlService.getS3BucketPath().subscribe(data => {
      //    let url = data + "/" + id;
      //    window.open(url);
      //  });
      //}
      else if (id.includes('http')) {
        window.open(id);
      }
    }

  }

  redirectToFootnotePath: any; 
  redirectToFootnote(event, temppath?: []) {    
    const eventpath : any  = event.composedPath() as Array<any>;
    if (eventpath.length !=0){
      this.redirectToFootnotePath = event.composedPath() as Array<any>;
    }
    else {
      this.redirectToFootnotePath = temppath;
    }

    event.preventDefault();
    const diamondLink = this.redirectToFootnotePath.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className.includes("diamond_link"));
    const firstAnchor = this.redirectToFootnotePath.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className.includes("xref"));
    const firstSpan = this.redirectToFootnotePath.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "");
    if (diamondLink && !firstAnchor.hasAttribute('routerlink')) {
      let href = firstAnchor.getAttribute('href');
      let otherSourceUrlParts = href?.split("/");
      let publicationId = otherSourceUrlParts[1];
      let pageId = otherSourceUrlParts[2];
      let footnoteId = href?.includes("#") ? href?.split("#")[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      //if (pageId != this.route.url.split("/")[2]) {
      window.open(location.origin + "/" + publicationId + "/" + pageId + "/" + footnoteId, '_blank').focus();//no need
      //}
      //else {
      //  if (document.getElementById(footnoteId) != null) {
      //    // document.getElementById(footnoteId).scrollIntoView(true);

      //    let footnoteDiv = document.getElementById(footnoteId);
      //    scrollIntoViewIfNeeded(footnoteDiv, {
      //      block: 'start',
      //      inline: 'start',
      //      behavior: 'smooth',
      //      boundary: document.getElementsByTagName('app-main-content')[0]
      //    })
      //  }
      //}
    }
    else if (firstAnchor && !firstAnchor.hasAttribute('routerlink')) {
      let href = firstAnchor.getAttribute('href');
      let otherSourceUrlParts = href?.split("/");
      let publicationId = otherSourceUrlParts[1];
      let pageId = otherSourceUrlParts[2];
      //Added for heading footnote click issue
      if (isNaN(pageId)) {
        publicationId = otherSourceUrlParts[0];
        pageId = otherSourceUrlParts[1];
      }
      let footnoteId = href?.includes("#") ? href?.split("#")[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      if (firstAnchor.innerHTML.toLocaleLowerCase().includes("<sup")) {
        footnoteId = firstAnchor?.getAttribute('href')?.includes("#") ? firstAnchor?.getAttribute('href')?.split("#")[1] : firstAnchor.getAttribute('href')?.split("/")[firstAnchor.getAttribute('href')?.split("/").length - 1];
        let footnoteLink1 = firstAnchor.id.includes("_Content") ? firstAnchor.id.replace("_Content", "") : firstAnchor.id + "_Content";
        if (document.getElementById(footnoteLink1) != null) {
          // document.getElementById(footnoteId).scrollIntoView(true);
          //let footnoteDiv = document.getElementById(footnoteLink1);
          //scrollIntoViewIfNeeded(footnoteDiv, {
          //  block: 'start',
          //  inline: 'start',
          //  behavior: 'smooth',
          //  boundary: document.getElementsByTagName('app-main-content')[0]
          //})
          //this.route.navigateByUrl(publicationId + "/" + pageId + "/" + footnoteLink1);
          this.popupRedirect(publicationId + "/" + pageId + "/" + footnoteLink1);

        } else {
          if (pageId != this.route.url.split("/")[2]) {
            //this.route.navigateByUrl(publicationId + "/" + pageId + "/" + footnoteId);//add
            this.popupRedirect(publicationId + "/" + pageId + "/" + footnoteId);

          }
        }
      }
      else {
        footnoteId = firstAnchor?.getAttribute('href')?.includes("#") ? firstAnchor?.getAttribute('href')?.split("#")[1] : firstAnchor.getAttribute('href')?.split("/")[firstAnchor.getAttribute('href')?.split("/").length - 1];
        //if (pageId != this.route.url.split("/")[2]) {
        //this.route.navigateByUrl(publicationId + "/" + pageId + "/" + footnoteId);
        this.popupRedirect(publicationId + "/" + pageId + "/" + footnoteId);
        //}
        //else {
        //  let historyData = {};
        //  let url: string = "";
        //  if (this.route.url.split("/").length > 3) {
        //    let urlFetched = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2];
        //    url = urlFetched + "/" + footnoteId;
        //  }
        //  else {
        //    url = this.route.url + "/" + footnoteId;
        //  }
        //  history.pushState(historyData, "scrollUrl", url);
        //  this.RetainInPagePosition(footnoteId, url);
        //}
      }
    }
    else if (firstSpan) {
      let href = firstSpan.getAttribute('href');
      let otherSourceUrlParts = href.split("/");
      let publicationId = otherSourceUrlParts[1];
      let pageId = otherSourceUrlParts[2];
      let footnoteId = firstSpan.getAttribute('href')?.includes('#') ? firstSpan.getAttribute('href')?.split('#')[1] : firstSpan.getAttribute('href')?.split("/")[firstSpan.getAttribute('href')?.split("/").length - 1];
      //if (pageId != this.route.url.split("/")[2]) {
      //this.route.navigateByUrl(publicationId + "/" + pageId + "/" + footnoteId);
      this.popupRedirect(publicationId + "/" + pageId + "/" + footnoteId);
      //} else {
      //  if (document.getElementsByName(footnoteId) != null) {
      //    // document.getElementById("footText" + firstSpan.id).scrollIntoView(true);
      //    let footTextDiv = document.getElementsByName(footnoteId)[0];
      //    scrollIntoViewIfNeeded(footTextDiv, {
      //      block: 'start',
      //      inline: 'start',
      //      behavior: 'smooth',
      //      boundary: document.getElementsByTagName('app-main-content')[0]
      //    })
      //  }
      //}
    }    
  }
  /* Start -- Annonation pop-up for print queue with MS -299 */
  popupRedirect(url) {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      //console.log('openlinkbyId');
      localStorage.setItem("isConfirmPopup", "true");
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          this.route.navigateByUrl(url);
        }
      });
      return;
    } else {
      this.route.navigateByUrl(url);
    }
  }
  /* End -- Annonation pop-up for print queue with MS -299 */

  //RetainInPagePosition(footnoteId, url) {
  //  url = url.startsWith("/") ? url.substring(1) : url;
  //  let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
  //  let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
  //  let scrollDataArray = JSON.parse(sessionStorage.getItem('inPageScrollPositionRetentionData'));
  //  let lastUrl = sessionStorage.getItem('inPageScrollLastUrl') == null ? this.route.url : sessionStorage.getItem('inPageScrollLastUrl');
  //  lastUrl = lastUrl.startsWith("/") ? lastUrl.substring(1) : lastUrl;
  //  let currentPosition = sessionStorage.getItem('inPageScrollCurrentNum') == null ? -1 : parseInt(sessionStorage.getItem('inPageScrollCurrentNum'));
  //  if (scrollDataArray == null) { scrollDataArray = []; }
  //  if (currentPosition == null) { currentPosition = -1; }
  //  if (top != undefined && height != undefined) {
  //    if (scrollDataArray.length == currentPosition + 1) {
  //      if (scrollDataArray[currentPosition] != undefined && scrollDataArray[currentPosition]?.url == lastUrl) {
  //        scrollDataArray[currentPosition].scrollHeight = height;
  //        scrollDataArray[currentPosition].scrollTop = top;
  //      } else {
  //        scrollDataArray.push({ scrollHeight: height, scrollTop: top, url: lastUrl });
  //        currentPosition = currentPosition + 1;
  //      }
  //      sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //    }
  //    else {
  //      scrollDataArray[currentPosition].scrollHeight = height;
  //      scrollDataArray[currentPosition].scrollTop = top;
  //      scrollDataArray[currentPosition].url = lastUrl;
  //      if (scrollDataArray.length > currentPosition + 1) {
  //        if (scrollDataArray[currentPosition + 1].url != url) {
  //          scrollDataArray[currentPosition + 1].url = url;
  //        }
  //      }
  //      sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //      currentPosition = currentPosition + 1;
  //    }
  //    sessionStorage.setItem("inPageScrollLastUrl", url);
  //    sessionStorage.setItem('inPageScrollCurrentNum', currentPosition.toString());

  //    let footnoteParaId = footnoteId.replace(footnoteId.split("__")[0] + "__", "");
  //    if (document.getElementById(footnoteId) != null) {
  //      let footnoteDiv = document.getElementById(footnoteId);
  //      scrollIntoViewIfNeeded(footnoteDiv, {
  //        block: 'start',
  //        inline: 'start',
  //        behavior: 'smooth',
  //        boundary: document.getElementsByTagName('app-main-content')[0]
  //      })
  //    }
  //    else if (document.getElementById(footnoteParaId) != null) {
  //      let footnoteDiv = document.getElementById(footnoteParaId);
  //      scrollIntoViewIfNeeded(footnoteDiv, {
  //        block: 'start',
  //        inline: 'start',
  //        behavior: 'smooth',
  //        boundary: document.getElementsByTagName('app-main-content')[0]
  //      })
  //    }
  //  }
  //}

  isRedirectionToFootnote(event) {
    const path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    const diamondLink = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className.includes("diamond_link"));
    const firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className.includes("xref"));
    const firstSpan = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "");
    if (diamondLink && !firstAnchor.hasAttribute('routerlink')) {
      let href = firstAnchor.getAttribute('href');
      let otherSourceUrlParts = href?.split("/");
      let publicationId = otherSourceUrlParts[1];
      let pageId = otherSourceUrlParts[2];
      let footnoteId = otherSourceUrlParts[otherSourceUrlParts.length - 1];
      return true;
    }
    else if (firstAnchor && !firstAnchor.hasAttribute('routerlink')) {
      let href = firstAnchor.getAttribute('href');
      let otherSourceUrlParts = href.split("/");
      let publicationId = otherSourceUrlParts[1];
      let pageId = otherSourceUrlParts[2];
      //Added for heading footnote click issue
      if (isNaN(pageId)) {
        publicationId = otherSourceUrlParts[0];
        pageId = otherSourceUrlParts[1];
      }
      let footnoteId = otherSourceUrlParts[otherSourceUrlParts.length - 1];
      if (firstAnchor.innerHTML.toLocaleLowerCase().includes("<sup")) {
        footnoteId = firstAnchor.getAttribute('href')?.includes('#') ? firstAnchor.getAttribute('href')?.split('#')[1] : firstAnchor.getAttribute('href')?.split("/")[firstAnchor.getAttribute('href')?.split("/").length - 1];
        let footnoteLink1 = firstAnchor.id.includes("_Content") ? firstAnchor.id.replace("_Content", "") : firstAnchor.id + "_Content";
        if (document.getElementById(footnoteLink1) != null) {
          return true;

        } else {
          if (pageId != this.route.url.split("/")[2]) {
            return true;
          }
        }
      }
      else {
        footnoteId = firstAnchor.getAttribute('href')?.includes('#') ? firstAnchor.getAttribute('href')?.split('#')[1] : firstAnchor.getAttribute('href')?.split("/")[firstAnchor.getAttribute('href')?.split("/").length - 1];
        return footnoteId != null && footnoteId != undefined && footnoteId != '' ? true : false;
      }
    }
    else if (firstSpan) {
      return true;
    }
  }
}
